var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, customElement, property } from 'lit-element';
import '../badges';
let TerminalDetails = class TerminalDetails extends LitElement {
    render() {
        if (this.data.deviceType == 'Ausgabeautomat') { //neue Ausgabeautomaten (OpenHardware)
            return html `
        <ul>
          <li>Karten: <feeder-badge .value=${this.data.feederState}></feeder-badge></li>
          <li>Farbband: <ribbon-badge .value=${this.data.ribbonState}></ribbon-badge></li>
        </ul>
      `;
        }
        if (this.data.type == 'Aktualisierer') { //neue Aktualisierer (OpenHardware)
            return html ` 
        <ul>
          <li>Reinigungszähler: <validations-badge .value=${this.data.cardsInsertedSinceCleaning}></validations-badge></li>
        </ul>
      `;
        }
        if (this.data.Type == 'Other') { //alte Ausgabeautomaten (TerminalAdministrator)
            return html `
        <ul>
          <li>Karten: <feeder-badge .value=${this.data.FeederState || 'No info'}></feeder-badge></li>
          <li>Farbband: <ribbon-badge .value=${this.data.RibbonState || 'No info'}></ribbon-badge></li>
        </ul>
      `;
        }
        if (this.data.Type == 'Validator') { //alte Aktualisierer (TerminalAdministrator)
            return html ` 
        <ul>
          <li>Reinigungszähler: <validations-badge .value=${this.data.CardInsertsSinceCleaning || 'No info'}></validations-badge></li>
        </ul>
      `;
        }
    }
};
TerminalDetails.styles = css `ul {margin: 0;}`;
__decorate([
    property()
], TerminalDetails.prototype, "data", void 0);
TerminalDetails = __decorate([
    customElement('terminal-details')
], TerminalDetails);
